<template>
    <div>
    <bossHeader/>
    <div class="bossMonitor">
      <el-row class="topContrast">
        <el-col :span="6" class="contrast">
          <div class="tit bosstips">
            昨日销售额
            <el-popover placement="bottom" width="200" popper-class="explain" trigger="hover">
              <p>周环比=昨天的数据/上周同一时期的数据*100%</p>
              <p>日环比=昨天的数据/昨天前一天的数据*100%</p>
              <i class="info" slot="reference"></i>
            </el-popover>
          </div>
          <div class="contrastCont">
            <h2><span>¥</span>{{salesBefor.yesterdayTotalSales}}</h2>
            <el-col :span="12">
              <p><span>周环比</span><span class="addtag">{{salesBefor.salesWeekSame}}</span></p>
            </el-col>
            <el-col :span="12">
              <p><span>日环比</span><span class="reducetag">{{salesBefor.salesDaysSame}}</span></p>
            </el-col>
          </div>
          <div class="bottom">
            <span class="left">当月累计销售额</span>
            <span class="right">¥ {{salesBefor.yesterdayTotalSales}}</span>
          </div>
        </el-col>
        <el-col :span="6" class="contrast">
          <div class="tit bosstips">昨日销售订单数</div>
          <div class="contrastCont">
            <h2>{{salesBefor.yesterdayTotalOrder}}</h2>
            <div class="chartlist" id="bar"></div>
          </div>
          <div class="bottom">
            <span class="left">月累计销售订单数</span>
            <span class="right">{{salesBefor.monthlyTotalOrder}}</span>
          </div>
        </el-col>
        <el-col :span="6" class="contrast">
          <div class="tit bosstips">
            昨日服务开单数
            <el-popover placement="bottom" width="200" popper-class="explain" trigger="hover">
              <p>周环比=昨天的数据/上周同一时期的数据*100%</p>
              <p>日环比=昨天的数据/昨天前一天的数据*100%</p>
              <i class="info" slot="reference"></i>
            </el-popover>
          </div>
          <div class="contrastCont">
            <h2>{{salesBefor.yesterdayServicesOpened}}</h2>
            <el-col :span="12">
              <p><span>周环比</span><span class="addtag">{{salesBefor.servicesWeekSame}}</span></p>
            </el-col>
            <el-col :span="12">
              <p><span>日环比</span><span class="reducetag">{{salesBefor.servicesDaysSame}}</span></p>
            </el-col>
          </div>
          <div class="bottom">
            <span class="left">当月累计服务开单</span>
            <span class="right">{{salesBefor.monthlyServicesOpened}}</span>
          </div>
        </el-col>
        <el-col :span="6" class="contrast xinzCont">
          <div class="tit">今日监控</div>
          <div class="contrastCont xinzCont_1">
            <el-col :span="12" style="border-right: 1px solid #ccc;">
              <p><span><b>销售总额</b></span></p>
              <p class="xinzCont_3"><span>¥{{salesBefor.todayTotalSales}}</span></p>
              <p class="xinzCont_3"><span>{{salesBefor.todayServicesOpen}}单</span></p>
            </el-col>
            <el-col :span="12">
              <p><span><b>服务开单数</b></span></p>
              <p class="xinzCont_3" style="color:#707BFA;font-size:24px;"><span>{{salesBefor.todayServicesOpen}}单</span></p>
            </el-col>
          </div>
          <div class="bottom" style="background: #fff;border-top:0px;"></div>
        </el-col>
      </el-row>
      <el-row class="title">
        <el-col :span='10' class="topTit">销售趋势</el-col>
        <el-col :span='14' class="tab">
          <el-button round @click="selectDate(3)" :class="{'active':comWeekActive}">本周</el-button>
          <el-button round @click="selectDate(2)" :class="{'active':comMonthActive}">本月</el-button>
          <el-button round @click="selectDate(1)" :class="{'active':comYearActive}">全年</el-button>
        </el-col>
      </el-row>
      <el-row class="saleVoute">
        <el-col :span="16">
          <div class="bosstips">销售额趋势</div>
          <div class="lineCont" id="line" ref="line"></div>
        </el-col>
        <el-col :span="8">
          <div class="bosstips">门店销售额排名</div>
          <div class="gundTip">
            <div class="storelist" v-for="(im,index) in salesStore" :key="index">
              <el-col :span="2"><span :class="{'first':index == 0,'second':index == 1,'third':index == 2,}">{{index+1}}</span></el-col>
              <el-col :span="17">{{im.shopName}}</el-col>
              <el-col :span="5">¥ {{im.salesAmount}}</el-col>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="title">
        <el-col :span='12' class="topTit">销售额品牌占比</el-col>
        <el-col :span='12' class="topTit pl28">
          <el-col :span="8"><span>销售额品类占比</span></el-col>
          <el-col :span="16">
            <div class="tab">
              <el-button round @click="pieCategBra(1)" :class="{'active':tmActive}">婷美摩力21</el-button>
              <el-button round @click="pieCategBra(2)" :class="{'active':zytActive}">臻幼堂</el-button>
              <el-button round @click="pieCategBra(3)" :class="{'active':mbsActive}">槑博士</el-button>
            </div>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="saleVoute percent">
            <div class="bosstips">
              <el-col :span="18">品牌分类</el-col>
              <el-col :span="6" class="tab">
                <el-date-picker v-model="dateValue" type="month" placeholder="选择月" style="width: 90%;" clear-icon value-format="yyyy-MM" @change="pieBrand"></el-date-picker>
              </el-col>
            </div>
            <div class="brandCont" id="pie1"></div>
            <div class="centerInfo"><span>销售额</span><p>¥{{totalBrand}}</p></div>
          </div>
        </el-col>
        <el-col :span="12">
            <div class="saleVoute percent fr">
               <div class="bosstips">
                <el-col :span="18">所有</el-col>
                <el-col :span="6" class="tab">
                  <el-date-picker v-model="dateTypeValue" type="month" placeholder="选择月" style="width: 90%;" clear-icon value-format="yyyy-MM" @change="pieCategory"></el-date-picker>
                </el-col>
              </div>
              <div class="brandCont" id="pie2"></div>
              <div class="centerInfo"><span>销售额</span><p>¥{{totalCateg}}</p></div>
            </div>
        </el-col>
      </el-row>
  </div>
  <Footer/>
  </div>
</template>
<script>
import bossHeader from "@/components/common/bossHeader";
import Footer from "@/components/common/Footer";
import {getBasicInfos,getSalesTrends, getStoreSalesRanks, getBrandSales, getCategorySales} from '@/api'
export default {
  components: {
    bossHeader,
    Footer
  },
  data(){
    return{
      searchDate:'',
      dateValue:'',
      dateTypeValue:'',
      lineLable:[],
      lineDataOption:[],
      lineData:[],
      comWeekActive:true,
      comMonthActive:false,
      comYearActive:false,
      salesBefor:{},
      salesStore:[],
      getBrand:[],
      totalBrand:0,
      piesBra:[],
      getCateg:[],
      totalCateg:0,
      pieCateg:[],
      tmActive:true,
      zytActive:false,
      mbsActive:false,
      pieCategB:1
    }
  },
  created() {
    this.selectDate(3);
    this.getBasic();
  },
  activated() {//进入页面就触发
    let Months = (new Date().getMonth()+1) < 10 ? '0' + (new Date().getMonth()+1) : (new Date().getMonth()+1);
    this.dateValue = new Date().getFullYear() + '-' + Months;
    this.dateTypeValue = new Date().getFullYear() + '-' + Months;
    this.pieBrand(this.dateValue);
    this.pieCategory(this.dateTypeValue);
  },
  methods: {
    pieCategBra(type){
      if(type == 1){
        this.tmActive = true;
        this.zytActive=false;
        this.mbsActive=false;
      }else if(type == 2){
        this.tmActive =false;
        this.zytActive=true;
        this.mbsActive=false;
      }else{
        this.tmActive =false;
        this.zytActive=false;
        this.mbsActive=true;
      }
      this.pieCategB = type;
      this.pieCategory(this.dateTypeValue);
    },
    pieCategory(val){
      getCategorySales({
        staffId:this.$store.state.userInfo.staffId,
        ymTime:val,
        brandId:this.pieCategB
      }).then(res => {
        this.pieCateg = [];
        this.totalCateg = 0;
        if(res.code == 1){
          this.getCateg = res.data;
          this.getCateg.forEach(item => {
            this.totalCateg = this.totalCateg + Number(item.salesAmount);
            this.pieCateg.push({value:Number(item.salesAmount), name:item.name,icon:'circle'})
          });
          this.getBrandS();
        }
      });
    },
    pieBrand(val){
      getBrandSales({
        staffId:this.$store.state.userInfo.staffId,
        ymTime:val
      }).then(res => {
        this.piesBra = [];
        this.totalBrand = 0;
        if(res.code == 1){
          this.getBrand = res.data;
          this.getBrand.forEach(item => {
            this.totalBrand = this.totalBrand + Number(item.salesAmount);
            this.piesBra.push({value:Number(item.salesAmount), name:item.name,icon:'circle'})
          });
          this.getBrandS();
        }
      });
    },
    getBasic(){
      getBasicInfos({staffId:this.$store.state.userInfo.staffId}).then(res => {
        if(res.code == 1){
          this.salesBefor = res.data;
          for(let i in this.salesBefor){
            if(this.salesBefor[i] == null){
              this.salesBefor[i] = 0;
            }
          }
        }
      })
    },
    selectDate(type){
      getSalesTrends({
        staffId:this.$store.state.userInfo.staffId,
        xType:type
      }).then(res => {
        this.lineLable = [];
        this.lineData = [];
        if(res.code == 1){
          this.lineDataOption = res.data;
          if(type == 3){
            this.comWeekActive = true;
            this.comMonthActive=false;
            this.comYearActive=false;
            this.lineDataOption.forEach(item => {
              this.lineLable.push(item.xaxis.slice(-2) +'日');
              this.lineData.push(item.salesAmount);
            });
            this.baroLine(3);
          }else if(type == 2){
            this.comWeekActive = false;
            this.comMonthActive=true;
            this.comYearActive=false;
            this.lineDataOption.forEach(item => {
              this.lineLable.push(item.xaxis.slice(-2) +'日');
              this.lineData.push(item.salesAmount);
            });
            this.baroLine(2);
          }else{
            this.comWeekActive = false;
            this.comMonthActive=false;
            this.comYearActive=true;
            this.lineDataOption.forEach(item => {
              this.lineLable.push(item.xaxis.slice(-2) +'月');
              this.lineData.push(item.salesAmount);
            });
            this.baroLine(1);
          }
        }
      });
      getStoreSalesRanks({
        staffId:this.$store.state.userInfo.staffId,
        xType:type
      }).then(res => {
        this.salesStore = [];
        if(res.code == 1){
          this.salesStore = res.data;
          this.salesStore.forEach((item,index) => {
            if(item.salesAmount == null){
              item.salesAmount = '0.00'
            }else{
              item.salesAmount = Number(item.salesAmount).toFixed(2)
            }
          });
          function sortBy(props) {
              return function(a,b) {
                  return b[props]-a[props] ;
              }
          }
          this.salesStore.sort(sortBy("salesAmount"));
        }
      });
    },
    baroLine(val){//柱状图-销售趋势
      this.$nextTick(() => {
        let baroption = {
            tooltip: {
              trigger: 'axis',
            },
            xAxis: {
              type: 'category',
              data: this.lineLable,
            },
            yAxis: {
              type: 'value',
              axisLine: {show: false},
              axisTick: {show: false},
              splitLine: {
                lineStyle: {type: 'dashed'}
              },
            },
            series: [{
              color:['#6187FB'],
              data: this.lineData,
              type: 'bar',
              barWidth:val == 2 ? 10 : 30,
            }]
        };
        echarts.init(document.getElementById('line')).setOption(baroption);
      });
    },
    getBrandS(){//饼图
      this.$nextTick(() => {
        let pie1data = this.piesBra;
        let pie2data = this.pieCateg;
        echarts.init(document.getElementById('pie1')).setOption(pieoption(pie1data));
        echarts.init(document.getElementById('pie2')).setOption(pieoption(pie2data));
        function pieoption(piedata) {
          return{
            tooltip: {
              trigger: 'item',
              formatter: "{b}:￥{c}"
            },
            legend: {
              // selectedMode:false,
              orient: 'vertical',
              top:30,
              right:10,
              data:piedata,
              formatter:  function(name){
                var target;
                for (var i = 0, l = piedata.length; i < l; i++) {
                  if (piedata[i].name == name) {
                    target = piedata[i].value;
                  }
                }
                return name + '     ' + '￥'+target;
              },
              itemGap:30,
              itemWidth:8,
              itemHeight:8,
              textStyle:{
                color:'#666',
                rich:{
                  a:{fontSize:20,verticalAlign:'top',align:'center',padding:[0,0,28,0]},
                  b:{fontSize:14,align:'center',padding:[0,10,0,0],lineHeight:25}
                }
              }
            },
            series: [
              {
                name:'品牌销售占比',
                type:'pie',
                radius: ['52%', '80%'],
                avoidLabelOverlap: false,
                selectedMode: 'single',
                itemStyle: {
                    normal: {
                        borderColor: '#fff',
                        borderWidth: 5,
                    },
                },
                center: ['30%', '50%'],
                color: ['#4ECB74','#FAD337','#36CBCB','#975FE4','#3AA0FF','#F2637B'],
                label: {
                  normal: {position: 'inner',formatter: '{d}% ',fontSize:12,},
                  emphasis: {show: true}
                },
                labelLine: {
                  normal: {show: false}
                },
                data:piedata
              }
            ]
          };
        }
      })
    },
  },
  mounted () {
    // 柱状图-昨日销售订单数
    let option = {
        xAxis: {
            show:false,
            type: 'category',
        },
        yAxis: {
            show:false,
            type: 'value',
            min:0,
            max:200
        },
        series: [{
            color:['#6187FB'],
            data: [120, 200, 150, 80, 70, 110, 130,120, 200, 150, 80, 70, 110, 130,60],
            type: 'bar',
            barWidth:9
        }]
    }
    echarts.init(document.getElementById('bar')).setOption(option);
  },
}
</script>
<style lang="less" scoped>
.bossMonitor{
    width: 1300px;
    margin: 0 auto;
    .bosstips{
        color: #444;
        font-weight: bold;
        position: relative;
        padding-left: 15px;
        line-height: 18px;
        &::before{
            content: '';
            width: 6px;
            height: 18px;
            background:linear-gradient(0deg,rgba(120,117,249,1) 0%,rgba(34,181,255,1) 100%);
            border-radius:3px;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
    .gundTip{
      height: 300px; overflow: auto;
    }
    /*滚动条样式*/
    .gundTip::-webkit-scrollbar {/*滚动条整体样式*/
        width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
    }
    .gundTip::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px #D2D5DD;
        background: rgba(0,0,0,0.2);
    }
    .gundTip::-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px #fff;
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }
    .topContrast{
        width: 100%;
        margin: 35px 0 0;
        .contrast{
            width: 24%;
            height: 250px;
            margin-right: 16px;
            background: #fff;
            border:1px solid rgba(213,217,227,1);
            border-radius:10px;
            position: relative;
            &:last-child{
                margin-right: 0;
            }
            .tit{
                margin: 25px 25px 0 35px;
                .info{
                    width: 25px;
                    height: 25px;
                    cursor: pointer;
                    position: absolute;
                    top: -4px;
                    right: 0;
                    background: url(../../assets/images/store/icon_warn.png) no-repeat center;
                    background-size: contain;
                }
            }
            .contrastCont{
                padding: 0 35px;
                color: #666;
                h2{
                    color: #222;
                    font-size: 40px;
                    margin-bottom:8%;
                    span{
                        font-size: 36px;
                    }
                }
                p{
                    font-size: 13px;
                }
                .addtag,.reducetag{
                    background: #FF7A6B;
                    border-radius: 5px;
                    padding: 2px 4px;
                    color: #fff;
                    margin-left: 12px;
                }
                .reducetag{
                    background: #35DC9B;
                }
                .chartlist{
                    width: 100%;
                    height: 82px;
                    position: absolute;
                    left: 0;
                    bottom: 26px;
                }
            }
            .xinzCont_1{
              p{text-align: center;}
              .xinzCont_3{font-size:20px;text-align: center;color:#189eff;font-weight: bolder;margin:8% 0 3%;}
            }
            .bottom{
                width: 100%;
                height: 48px;
                line-height: 48px;
                border-radius:0 0 10px 10px;
                padding: 0 30px 0 35px;
                background: #fdfdff;
                position: absolute;
                bottom: 0;
                left: 0;
                border-top: 1px solid #D5D9E3;
                .left{
                    color: #666;
                    font-size: 13px;
                    float: left;
                }
                .right{
                    font-size: 15px;
                    color: #666;
                    font-weight: bold;
                    float: right;
                }
            }
        }
        .xinzCont{
          .tit{font-size:26px;text-align: center;color: #f59a23;font-weight: bolder;margin-bottom:10%;}
        }
    }
    .title{
        margin: 22px 0 15px;
        .topTit{
            font-size: 17px;
            color: #444;
            font-weight: bold;
            line-height: 40px;
        }
    }
    .pl28{
        padding-left: 28px;
    }
    .tab{
        text-align: right;
        .el-button{
            min-width: 68px;
            margin-left: 0;
            padding: 12px;
            &:hover,&:focus,&:active,&.active{
                background:linear-gradient(90deg,rgba(120,117,249,1) 0%,rgba(34,181,255,1) 100%);
                color: #fff;
            }
        }
        .el-range-editor.el-input__inner{
            width: 240px;
            border-radius: 20px;
        }
    }
    .saleVoute{
        background: #fff;
        border: 1px solid #D5D9E3;
        border-radius: 9px;
        height: 445px;
        padding: 40px 68px 78px 35px;
        .lineCont{
            height: 370px;
        }
        .storelist{
            overflow: hidden;
            margin-top: 30px;
            color: #666;
            font-size: 13px;
            span{
                color: #444;
                font-size: 11px;
                width: 20px;
                height: 20px;
                background: #D2D5DD;
                float: left;
                border-radius: 50%;
                text-align: center;
                &.first{
                    background: #FF7A6B;
                    color: #fff;
                }
                &.second{
                    background: #FFA820;
                    color: #fff;
                }
                &.third{
                    background: #FFC83F;
                    color: #fff;
                }
            }
            &.mb50{
                margin-top: 50px;
            }
        }
        &.percent{
            width: 630px;
            height: 418px;
            padding: 40px 50px 65px 35px;
            position: relative;
            .bosstips{
                height: 20px;
                .tab{
                    margin-top: -10px;
                }
            }
        }
        .brandCont{
            height: 340px;
        }
        .centerInfo{
            position: absolute;
            top: 51%;
            left: 150px;
            color: #222;
            text-align: center;
            span{
                color: #999;
                font-size: 13px;
            }
            p{
                font-size: 22px;
            }
        }
    }
}
</style>
<style lang="less">
.el-popover.explain{
    width:220px;
    background: #F9F9FA;
    font-size:11px;
    color:#999;
    line-height:22px;
}
.tab{
    .el-select .el-input__inner{
        width:130px;
        border:none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/bossCenter/bossCenter.vue